import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorContactSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M3.042 5.06a.75.75 0 0 1 1.047-.168l7.83 5.654a1.25 1.25 0 0 0 1.463 0l7.829-5.654a.75.75 0 0 1 .878 1.216l-7.829 5.654a2.75 2.75 0 0 1-3.22 0L3.21 6.108a.75.75 0 0 1-.168-1.047ZM6.15 13.75a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M10 17.25h10c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v6a.75.75 0 0 1-1.5 0V6A2.75 2.75 0 0 1 5 3.25h15A2.75 2.75 0 0 1 22.75 6v10A2.75 2.75 0 0 1 20 18.75H10a.75.75 0 0 1 0-1.5Z"
    />
  </svg>
);
export default SvgTwoColorContactSupport;
